import { Injectable } from '@angular/core';
import { gql, Apollo } from 'apollo-angular';
import { pluck } from 'rxjs/operators';
const getSupplyCategoriesQuery = gql`query get_supply_categories{
  supply_categories(order_by: {name: asc}){
    id
    name
    created_at
    updated_at
  }
}`;
@Injectable()
export class GetSupplyCategoriesService {
  /* ------------------------------- Constructor ------------------------------ */
  constructor(private apollo: Apollo) { }
/* -------------------------- Get Supply Categories ------------------------- */
  getSupplyCategories(){
    return this.apollo.use('external').query({
      query: getSupplyCategoriesQuery
    }).pipe(pluck('data', 'supply_categories'))
  }
}
